// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recommendation-list[data-v-b2a85db0]{list-style-type:none;padding:0;display:flex;flex-direction:column;gap:16px;max-width:1052px;margin:auto}.text-recommendation-container[data-v-b2a85db0]{container-type:inline-size}", ""]);
// Exports
module.exports = exports;
